import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import loading from '../../../../images/loading.gif';
import { EkioskConfigMessageKeys, IKIOSKModel, IKioskMessage } from '../../../../models/kioskModel';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const PageLoading: React.FC = () => {
    const loadings: boolean = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.loading || false);
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    const { t } = useTranslation("translations");
    return (
        <>
            {loadings && <div className='d-flex flex-column align-items-center processing_msg'>

                <span>{(getLabelConfigMsg(kioskConfigMsgs,language,EkioskConfigMessageKeys.FATCHINGMES) || t("kiosktranslation.loadMes" + language))}</span>

                <img src={loading} alt={t("kiosktranslation.loading" + language)} width="140" />
            </div>}
        </>)
}

export default React.memo(PageLoading);